import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    flex: 1,
    height: "100%",
    // Todo o respiro da página (lateral e superior) mora aqui, e só aqui.
    // Antes era `padding: 0` e cada página resolvia por conta — a maioria não
    // resolvia, daí o conteúdo colado na sidebar e o título colado no AppBar.
    // PageHeader e DataTable de propósito não trazem padding próprio para não
    // dobrar com este.
    padding: theme.spacing(2.5, 3, 0),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2, 1.5, 0),
    },
  },

  contentWrapper: {
    height: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
  },
}));

const MainContainer = ({ children }) => {
  const classes = useStyles();

  return (
    <Container className={classes.mainContainer} maxWidth={false}>
      <div className={classes.contentWrapper}>{children}</div>
    </Container>
  );
};

export default MainContainer;
